import { useState, useEffect } from 'react';
import { Box, Paper, Typography, Container, useTheme, useMediaQuery, Alert } from '@mui/material';
import RegistrationForm from '../components/auth/RegistrationForm';
import logo from '../assets/img/logo.png';
import api from '../services/api';

const Register = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [message, setMessage] = useState('');

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await api.get('/settings/motd_registration');
                if (response.data.success && response.data.data) {
                    setMessage(response.data.data.value);
                }
            } catch (error) {
                console.error('Failed to fetch settings:', error);
            }
        };
        fetchSettings();
    }, []);

    return (
        <Box
            sx={{
                minHeight: 'calc(100vh - 64px)', // Adjust for header height
                display: 'flex',
                alignItems: 'center',
                backgroundColor: 'background.default',
                padding: 2
            }}
        >
            <Container maxWidth="md">
                <Paper
                    elevation={3}
                    sx={{
                        padding: isMobile ? 3 : 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        borderRadius: 2,
                        boxShadow: theme.shadows[3]
                    }}
                >
                    <img 
                        src={logo} 
                        alt="Total Turf Experience"
                        style={{
                            width: isMobile ? '150px' : '200px',
                            height: 'auto',
                            marginBottom: '1.5rem'
                        }}
                    />
                    <Typography 
                        variant="h5" 
                        component="h1" 
                        gutterBottom
                        sx={{
                            color: theme.palette.primary.main,
                            fontWeight: 'bold',
                            fontSize: isMobile ? '1.5rem' : '1.75rem',
                            textAlign: 'center'
                        }}
                    >
                        Create Your Account
                    </Typography>
                    <Typography 
                        variant="body2" 
                        color="text.secondary" 
                        mb={3}
                        sx={{
                            textAlign: 'center',
                            maxWidth: '80%'
                        }}
                    >
                        Join Total Turf Experience and get access to our facilities
                    </Typography>
                    {message && (
                        <Alert 
                            severity="info" 
                            sx={{ 
                                mb: 3,
                                width: '100%'
                            }}
                        >
                            <div dangerouslySetInnerHTML={{ __html: message }} />
                        </Alert>
                    )}
                    <RegistrationForm />
                </Paper>
            </Container>
        </Box>
    );
};

export default Register; 